import { ReportGeneratedStatus } from "@validereinc/domain";
import { convertMapToOpts } from "../shared/index.ts";
import { toStartCaseString } from "@validereinc/utilities";

export const ReportGeneratedStatusOptions = convertMapToOpts(
  ReportGeneratedStatus,
  ([_, label]) => toStartCaseString(label)
);
